import React from "react";

import { useSessionStorage } from "./services/useSessionStorage";

const ProgramsContext = React.createContext();

const useProgramsContext = (client) => {
  const [context, setContext] = useSessionStorage("programs", null);
  if (context === null) {
    console.time("Querying for Programs");
    client
      .query(getProgramsQuery)
      .toPromise()
      .then((response) => {
        if (response.error) throw new Error(response.error);
        setContext(
          response.data?.programs.sort((a, b) =>
            a.name.localeCompare(b.name, "en", { sensitivity: "base" }),
          ),
        );
        console.timeEnd("Querying for Programs");
      })
      .catch((e) => {
        if (/Token has expired\./.test(e.toString()))
          window.location.replace("/logout.html");
      });
  }
  return [context, setContext];
};

const getProgramsQuery = `
  query GetPrograms {
    programs {
      id
      itemNamePrefix
      name
      configurationID
      keywords {
        description
        value
      }
      metafileAssets {
        category
        comment
        fileTimestamp
        itemAssociations
        name
        passageAssociations
      }
      _actions
    }
  }`;

export { ProgramsContext, useProgramsContext };
